export default class Collapsible {
  toggle(event, element, targetElement) {
    event.preventDefault()
    $(element).find('.collapse-icon').toggleClass('d-none')
    $(targetElement).slideToggle('show')
  }
}
